enum UserBookmarkSortOption {
    CreatedOnAscending = 0,
    CreatedOnDescending = 1,
    BookOrder = 2,
}

export default UserBookmarkSortOption;
